export const NotiData = [
  {
    id: 1,
    name: "Cập nhật món hàng: Hóa đại cương 1",
    vendor: "Uchiha Itachi",
    msg: "Đã bán",
    time: "30 phút trước",
    img: "http://res.cloudinary.com/dath/image/upload/v1672074764/drmflkvsrrs3wkwtjtne.png",
    link: "/item/63a9e09406c3723a70d3f0ca",
  },
  {
    id: 2,
    name: "Cập nhật món hàng: Giáo trình Giải tích",
    vendor: "Uchiha Itachi",
    msg: "Đã bán",
    time: "2 giờ trước",
    img: "http://res.cloudinary.com/dath/image/upload/v1672077420/qjooofjaj0j81yw67ls4.jpg",
    link: "/item/63a9e06d06c3723a70d3f0b1",
  },
  {
    id: 3,
    name: "Cập nhật món hàng: Giải bài tập giải tích",
    vendor: "Uchiha Sasuke",
    msg: "Đã bán",
    time: "1 ngày trước",
    img: "http://res.cloudinary.com/dath/image/upload/v1672077420/qjooofjaj0j81yw67ls4.jpg",
    link: "/item/63a9d65bc3d09912b024b5fd",
  },
];